import dayjs from 'dayjs';

import type { PlanFieldConfig, FieldTransform } from '../config/tpoGenConfig';

const TRANSFORMS: Record<FieldTransform, (v: unknown) => unknown> = {
    year: (v) => dayjs(v as Parameters<typeof dayjs>[0]).year(),
};

export function buildPlanPayload(
    fields: PlanFieldConfig[],
    formValues: Record<string, unknown>,
): Record<string, unknown> {
    const payload: Record<string, unknown> = {};
    for (const field of fields) {
        if (!field.apiKey || !field.name) continue;
        const raw = formValues[field.name];
        if (raw === undefined || raw === null) continue;
        payload[field.apiKey] = field.transform
            ? TRANSFORMS[field.transform](raw)
            : raw;
    }
    return payload;
}
